
<template>
    <section class="flex-column hp-10 jc-center ai-center br b-1 white-bkg">
        <icon-svg icon-name="confirmed" :width="117" :height="111" viewBox="0 0 117 111"><icon-check/></icon-svg>
        <h1 class="mt-8 mb-0">{{ $l10n.__("Tout est bon !") }}</h1>
        <p class=" mt-3 mb-4 fs-3 confirmed-subtitle acenter">{{ $l10n.__("Vous pouvez désormais configurer une page publique pour que vos contacts programment un rendez-vous en toute autonomie.") }}</p>
        <nylas-scheduler class="btn btn-primary">
            <div slot="label">
                {{ $l10n.__('Continuer') }}
            </div>
        </nylas-scheduler>
    </section>
</template>

<script>
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconCheck from 'vcomponents/icons/IconSvgCheck.vue';
import NylasScheduler from 'vcomponents/scheduler/NylasScheduler.vue';

export default {
    components: {
        IconSvg,
        IconCheck,
        NylasScheduler
    }
}
</script>

<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';
    @import '~@sellsy/styleguide/src/_mixins';

    .confirmed-subtitle {
        width: 400px;
    }
</style>
